var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('status-displayer',{attrs:{"color":_vm.LoraForwarderStateColor.get(_vm.state),"status":_vm.state.capitalizeFirst()}})}
var staticRenderFns = []

export { render, staticRenderFns }